import { render, staticRenderFns } from "./WDualListAutocomplete.vue?vue&type=template&id=0fb6a7a6&scoped=true&"
import script from "./WDualListAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WDualListAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6a7a6",
  null
  
)

export default component.exports